export enum gptModel {
  gpt_4o_mini = 'gpt-4o-mini',
  gpt_4 = 'gpt-4',
}
